var SearchResultType;
(function (SearchResultType) {
    SearchResultType["PRODUCTS"] = "products";
    SearchResultType["PRODUCTS_ALT"] = "productsalt";
    SearchResultType["PAGES"] = "pages";
    SearchResultType["BLOGS"] = "blogs";
})(SearchResultType || (SearchResultType = {}));

export { SearchResultType };
